import commentLoad from '../libraries/comment-load'

export default (store_id, token) => {

  Array.from(document.getElementsByClassName('comment-submit')).forEach(el => {
    el.addEventListener('click', (e) => {
      Array.from(document.getElementsByClassName('comment-input')).forEach(comment =>{
        if (comment.value.length == 0) return

        const data = {store_comment: {comment: comment.value, store_id: store_id}}

        const xhr = new XMLHttpRequest()
        xhr.open('POST', '/api/v1/store_comments')
        xhr.setRequestHeader('X-CSRF-Token', token)
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.send(JSON.stringify(data))
        xhr.addEventListener('load', function(result) {
          if (result.currentTarget.status == 204) {
            comment.value = ''
            commentLoad(store_id, token, 30)
          } else if (result.currentTarget.responseText.length > 0) {
            alert(result.currentTarget.responseText)
          }
        })
      })
    })
  })

}
